import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Layout from "@/components/Layout";
import { PlayerProvider } from "@/context/PlayerContext";
import Home from "@/pages/Home";
import Songs from "@/pages/Songs";
import SongDetail from "@/pages/SongDetail";
import Videos from "@/pages/Videos";
import Albums from "@/pages/Albums";
import Store from "@/pages/Store";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Library from "@/pages/Library";
import Gift from "@/pages/Gift";
import PlaylistView from "@/pages/PlaylistView";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminForgot from "@/pages/AdminForgot";
import AdminReset from "@/pages/AdminReset";
import AdminDashboard from "@/pages/AdminDashboard";
import AuthCallback from "@/pages/AuthCallback";

/**
 * AppRouter — inspects the URL fragment synchronously (from useLocation().hash so it stays reactive)
 * and hijacks rendering when Emergent Auth returns a session_id, before any Route matches.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH.
 */
function AppRouter() {
  const location = useLocation();
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/songs" element={<Songs />} />
        <Route path="/songs/:id" element={<SongDetail />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/albums" element={<Albums />} />
        <Route path="/store" element={<Store />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/library" element={<Library />} />
        <Route path="/gift/:code" element={<Gift />} />
        <Route path="/playlists/:code" element={<PlaylistView />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/forgot" element={<AdminForgot />} />
        <Route path="/admin/reset/:token" element={<AdminReset />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PlayerProvider>
          <AppRouter />
        </PlayerProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
